import { useRedirectToMainDomain } from './hooks/useRedirectToMainDomain'

export const SubdomainGuard: React.FC = () => {
  const { redirectUrl } = useRedirectToMainDomain()
  if (redirectUrl) window.location.href = redirectUrl
  return null
}
